// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__fW+Xn","ButtonActive":"Button_ButtonActive__Px9IY","fa-scroll":"Button_fa-scroll__OHy6h","notes":"Button_notes__tHLEx","notes_btn":"Button_notes_btn__pWUmD"};